import { gql } from 'graphql-request';
import useSWRMutation from 'swr/mutation';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import { BasketFragment } from '@graphql/fragments';
import { basketRequest } from '@hooks/basket/_utils';
import { formatBasket, useBasketMutation } from '@hooks/basket/useBasket';
import { useCustomerIdToken } from '@hooks/customer';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { productRemoved } from '@repo/ui/src/services/analytics';
import { gcToAnalytics } from '@repo/ui/src/services/analytics/factories';
import { GiftCard } from '@repo/ui/src/types/basket';
import { GraphQLRequestWithTokenProps } from '@repo/ui/src/utils/graphql-request';

export const deleteGiftCardFromBasket = gql`
  ${BasketFragment}
  mutation DeleteGiftCard($giftCardId: ID!) {
    deleteGiftCardFromBasket(giftCardId: $giftCardId) {
      ...Basket
    }
  }
`;

interface Key extends GraphQLRequestWithTokenProps {
  productGeo: string;
  locale: string;
}
const fetcher = async (key: Key, { arg: item }: { arg: GiftCard }) => {
  const { deleteGiftCardFromBasket: basket } = await basketRequest({
    ...key,
    variables: {
      giftCardId: item.id,
    },
  });
  productRemoved({
    ...gcToAnalytics(item),
    basket_token: basket.basketJWT,
    affiliation: 'website',
    brand: 'Traeger',
    locale: key.locale,
    cart_id: basket.id,
    currency: basket.currency,
    list_name: '',
  });
  return basket;
};
export const useRemoveGCFromBasket = () => {
  const { locale, productGeo } = useCurrentUrl();
  const idToken = useCustomerIdToken();
  const mutate = useBasketMutation();
  const { push } = useModal(ModalID.cart);
  return useSWRMutation(
    {
      document: deleteGiftCardFromBasket,
      locale,
      idToken,
      productGeo,
    },
    fetcher,
    {
      onSuccess: async (basket) => {
        const formattedBasket = formatBasket(basket, locale);
        await mutate(formattedBasket, { revalidate: false });
        push();
      },
    },
  );
};
